import React from 'react';
import {Container, Typography, Link} from '@mui/material';
import {Link as RouterLink} from 'react-router-dom'; // This is assuming you are using react-router-dom for routing

const DataDeletion = () => {
    return (
        <Container component="main" maxWidth="md" sx={{mt: 4, mb: 4}}>
            <Typography variant="h4" gutterBottom>
                Data Deletion Instructions
            </Typography>
            <Typography variant="body1" paragraph>
                If you wish to request the deletion of your personal data held by EchoBud, please follow the
                instructions below to submit your request through our contact form.
            </Typography>
            <Typography variant="body1" paragraph>
                We are committed to maintaining your privacy and allowing you full control over your data. To proceed
                with your data deletion request, please provide us with the necessary details to identify and delete
                your data.
            </Typography>
            <Typography variant="body1" paragraph>
                Click the button below to navigate to our contact form, where you can submit your data deletion request.
                Please ensure to specify that your inquiry is about 'Data Deletion'.
            </Typography>
            <Link color="secondary" component={RouterLink} to="/contact">Go to Contact Form</Link>
        </Container>
    );
};

export default DataDeletion;
